<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <!-- 第一行筛选条件 -->
          <el-form-item label="打赏人身份类型：">
            <el-select v-model="query.giverLevelType" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="客户级别" :value="1"></el-option>
              <el-option label="技术老师" :value="2"></el-option>
              <el-option label="内部员工" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="打赏人身份：">
            <el-input v-model="query.giverLevelId" placeholder="请输入身份ID" clearable size="small" />
          </el-form-item>
          <el-form-item label="打赏人手机号：">
            <el-input v-model="query.giverPho" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="主播身份类型：">
            <el-select v-model="query.anchorLevelIdType" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="客户级别" :value="1"></el-option>
              <el-option label="技术老师" :value="2"></el-option>
              <el-option label="内部员工" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主播身份：">
            <el-input v-model="query.anchorLevelId" placeholder="请输入身份ID" clearable size="small" />
          </el-form-item>
          <el-form-item label="主播手机号：">
            <el-input v-model="query.anchorPho" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          
          <!-- 第二行筛选条件 -->
          <el-form-item label="直播间ID：">
            <el-input v-model="query.liveId" placeholder="请输入直播间ID" clearable size="small" />
          </el-form-item>
          <el-form-item label="直播主题：">
            <el-input v-model="query.levelTitle" placeholder="请输入直播主题" clearable size="small" />
          </el-form-item>
          <el-form-item label="支付方式：">
            <el-select v-model="query.type" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="零售价" :value="2"></el-option>
              <el-option label="微信支付" :value="10"></el-option>
              <el-option label="支付宝支付" :value="20"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态：">
            <el-select v-model="query.state" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="未支付" :value="0"></el-option>
              <el-option label="已支付" :value="1"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    
    <el-card class="box-card mt10">
      <!-- 统计信息和导出按钮 -->
      <div class="statistics-container mb10">
        <div class="statistics-info">
          <span class="stat-item">打赏人数: {{ statistics.giverCount }}人</span>
          <span class="stat-item">打赏次数: {{ statistics.rewardCount }}次</span>
          <span class="stat-item">现金打赏: {{ statistics.cashAmount }}元</span>
          <span class="stat-item">零售价打赏: {{ statistics.coinAmount }}零售价</span>
        </div>
        <div class="export-btn">
          <el-button type="primary" size="mini" @click="handleExport" plain>导出</el-button>
        </div>
      </div>
      
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="打赏人信息" align="center">
          <template slot-scope="{row}">
            <span>{{ row.rewardUserInfo || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="直播信息" align="center">
          <template slot-scope="{row}">
            <span>{{ row.liveInfo || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="主播姓名" prop="anchorName" align="center" />
        <el-table-column label="主播身份" prop="anchorIdentity" align="center" />
        <el-table-column label="主播手机号" prop="anchorPho" align="center" />
        <el-table-column label="打赏物品" align="center">
          <template slot-scope="{row}">
            <div v-if="row.rewardImgUrl && row.rewardImgUrl !== '无'">
              <el-image :src="row.rewardImgUrl" style="width: 30px; height: 30px;" :preview-src-list="[row.rewardImgUrl]" />
            </div>
            <span v-else>{{ row.rewardName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付方式" align="center">
          <template slot-scope="{row}">
            <span v-if="row.type === 2">零售价</span>
            <span v-else-if="row.type === 10">微信支付</span>
            <span v-else-if="row.type === 20">支付宝支付</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" align="center">
          <template slot-scope="{row}">
            <el-tag v-if="row.state === 0" type="info">未支付</el-tag>
            <el-tag v-else-if="row.state === 1" type="success">已支付</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="打赏金额" prop="money" align="center">
          <template slot-scope="{row}">
            <span>{{ row.money || 0 }}</span>
            <span v-if="row.type === 1">零售价</span>
            <span v-else-if="row.type === 2">元</span>
          </template>
        </el-table-column>
        <el-table-column label="打赏次数" prop="rewardCount" align="center" />
        <el-table-column label="订单号" prop="orderNum" align="center" />
        <el-table-column label="创建时间" prop="createdTime" align="center" sortable="custom">
          <template slot-scope="{row}">
            <span>{{ row.createdTime | formatDate }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import liveRewardOrderApi from '@/api/live/liveRewardOrder'
import Pagination from '@/components/Pagination'
import { formatDate } from '@/utils/dateTime'

export default {
  components: {
    Pagination,
  },
  filters: {
    formatDate
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        giverPho: '', // 打赏人手机号
        anchorPho: '', // 主播手机号
        liveId: '', // 直播间id
        levelTitle: '', // 直播主题
        giverLevelId: null, // 打赏人身份
        giverLevelType: null, // 打赏人身份类型 1客户级别 2技术老师 3内部员工
        anchorLevelId: '', // 主播身份
        anchorLevelIdType: null, // 主播身份类型 1客户级别 2技术老师 3内部员工
        type: null, // 支付方式 1零售价 2现金
        state: null, // 订单状态 0未支付 1已支付
        createdTimeSortSign: null // 创建时间排序标识【1升序,-1降序,0不排序】
      },
      statistics: {
        giverCount: 0,
        rewardCount: 0,
        cashAmount: 0,
        coinAmount: 0
      },
      selectItems: []
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    /**
     * 导出数据
     */
    handleExport() {
      // 使用红框标记的参数：anchorPho, levelTitle, liveId, state
      const query = {
        code: 'ExportLiveRewardOrder'
      }
      if (this.query.anchorPho) query.anchorPho = this.query.anchorPho
      if (this.query.levelTitle) query.levelTitle = this.query.levelTitle
      if (this.query.liveId) query.liveId = this.query.liveId
      if (this.query.state !== null && this.query.state !== undefined) query.state = this.query.state
      
      // 直接跳转到导出页面，传递参数
      this.$router.push({
        path: '/export/list',
        query: query
      })
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        giverPho: '',
        anchorPho: '',
        liveId: '',
        levelTitle: '',
        giverLevelId: null,
        giverLevelType: null,
        anchorLevelId: '',
        anchorLevelIdType: null,
        type: null,
        state: null,
        createdTimeSortSign: null
      }
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'rewardTime': 'rewardTimeSortSign',
        'createdTime': 'createdTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      // 构建查询参数，过滤空值
      const params = {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize
      }
      if (this.query.giverPho) params.giverPho = this.query.giverPho
      if (this.query.anchorPho) params.anchorPho = this.query.anchorPho
      if (this.query.liveId) params.liveId = this.query.liveId
      if (this.query.levelTitle) params.levelTitle = this.query.levelTitle
      if (this.query.giverLevelId !== null && this.query.giverLevelId !== '') params.giverLevelId = this.query.giverLevelId
      if (this.query.giverLevelType !== null) params.giverLevelType = this.query.giverLevelType
      if (this.query.anchorLevelId) params.anchorLevelId = this.query.anchorLevelId
      if (this.query.anchorLevelIdType !== null) params.anchorLevelIdType = this.query.anchorLevelIdType
      if (this.query.type !== null) params.type = this.query.type
      if (this.query.state !== null) params.state = this.query.state
      if (this.query.createdTimeSortSign !== null) params.createdTimeSortSign = this.query.createdTimeSortSign
      
      return liveRewardOrderApi.fetchList(params)
        .then(data => {
          this.list = data.data.list || []
          this.total = data.data.total || 0
          // 获取统计信息
          this.fetchStatistics()
        })
        .catch(err => {
          console.error('获取打赏记录失败:', err)
          this.$message.error(err.message || '获取打赏记录失败')
          this.list = []
          this.total = 0
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 获取统计信息
     */
    fetchStatistics() {
      const params = {}
      if (this.query.giverPho) params.giverPho = this.query.giverPho
      if (this.query.anchorPho) params.anchorPho = this.query.anchorPho
      if (this.query.liveId) params.liveId = this.query.liveId
      if (this.query.levelTitle) params.levelTitle = this.query.levelTitle
      if (this.query.giverLevelId !== null && this.query.giverLevelId !== '') params.giverLevelId = this.query.giverLevelId
      if (this.query.giverLevelType !== null) params.giverLevelType = this.query.giverLevelType
      if (this.query.anchorLevelId) params.anchorLevelId = this.query.anchorLevelId
      if (this.query.anchorLevelIdType !== null) params.anchorLevelIdType = this.query.anchorLevelIdType
      if (this.query.type !== null) params.type = this.query.type
      if (this.query.state !== null) params.state = this.query.state
      
      liveRewardOrderApi.listStatistics(params)
        .then(data => {
          if (data.code === '0' && data.data) {
            this.statistics = {
              giverCount: data.data.userCount || 0,
              rewardCount: data.data.orderCount || 0,
              cashAmount: data.data.moneyCashPay || 0,
              coinAmount: data.data.moneyXiaoduCoinPay || 0
            }
          }
        })
        .catch(err => {
          console.error('获取统计信息失败:', err)
        })
    },
    // /**
    //  * 导出数据
    //  */
    // handleExport() {
    //   // 使用红框标记的参数：anchorPho, levelTitle, liveId, state
    //   const params = {}
    //   if (this.query.anchorPho) params.anchorPho = this.query.anchorPho
    //   if (this.query.levelTitle) params.levelTitle = this.query.levelTitle
    //   if (this.query.liveId) params.liveId = this.query.liveId
    //   if (this.query.state !== null && this.query.state !== undefined) params.state = this.query.state
      
    //   // 调用导出接口
    //   liveRewardOrderApi.exportCourseOrder(params)
    //     .then(response => {
    //       if (response.code === '0' && response.data && response.data.code) {
    //         // 获取任务code，跳转到导出页面
    //         this.$router.push({
    //           path: '/export/list',
    //           query: {
    //             code: response.data.code
    //           }
    //         })
    //         this.$message.success('导出任务已创建，正在跳转到下载页面')
    //       } else {
    //         this.$message.error('导出失败：' + (response.msg || '未获取到任务代码'))
    //       }
    //     })
    //     .catch(error => {
    //       console.error('导出任务创建失败:', error)
    //       this.$message.error('导出任务创建失败：' + (error.message || '未知错误'))
    //     })
    // }
  }
}
</script>

<style scoped>
.statistics-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.statistics-info {
  display: flex;
  gap: 20px;
}

.stat-item {
  font-size: 14px;
  color: #606266;
}

.export-btn {
  margin-left: auto;
}

.mb10 {
  margin-bottom: 10px;
}

.mt10 {
  margin-top: 10px;
}
</style>